import type { CountryCode } from "@/types/i18n";

export const countryFlagSources: Partial<Record<CountryCode, string>> = {
  FR: "/assets/images/flags/country-fr.png",
  US: "/assets/images/flags/country-en.png",
};

export const FLAG_IMAGE_SIZE = 20;
